<freud-dialog
	[closable]="false"
	[showHeader]="true"
	[header]="'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.TITLE' | translate"
	[modal]="true"
	[visible]="visible"
  [draggable]="false"
>
	<div body class="md:zk-mt-0 sm:zk-mt-6">
    <div class="zk-h-30 zk-flex zk-items-center zk-justify-center" *ngIf="isLoading">
      <freud-loader></freud-loader>
    </div>
    <div *ngIf="!isLoading">
      <div class="zk-mb-8">
        <freud-multi-select
          [(ngModel)]="_selectedContacts"
          [disabled]="disabledSelect"
          [label]="'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.SELECT.LABEL'| translate"
          [options]="_options"
          display="chip"
          [invalid]="invalidSelect"
        ></freud-multi-select>
      </div>
      <freud-input-textarea
        [(ngModel)]="_message"
        [label]="'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.TEXTAREA.LABEL' | translate"
        [rows]="9"
        [autoResize]="false"
        [invalid]="invalidText"
      ></freud-input-textarea>
    </div>

	</div>
  <div freudTemplatefooter class="zk-flex sm:zk-flex-col md:zk-flex-row zk-w-full zk-pt-4">
    <div [ngClass]="!_selectedContacts?.length ? 'text-transparent' : 'actions-info'" class="zk-flex sm:zk-justify-center md:zk-justify-start zk-items-center zk-text-sm md:zk-mr-4 sm:zk-mb-2 md:zk-mb-0 zk-w-full">
      <span class="freud-icon freud-icon-info-circle freud-icon-md zk-mr-2"></span>
      <span class="zk-text-left" *ngIf="_selectedContacts.length < 2">{{'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.ACTIONS.INFO_1' | translate}} {{_selectedContacts.length || 0}} {{'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.ACTIONS.INFO_2_SINGULAR' | translate}}</span>
      <span class="zk-text-left" *ngIf="_selectedContacts.length > 1">{{'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.ACTIONS.INFO_1' | translate}} {{_selectedContacts.length || 0}} {{'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.ACTIONS.INFO_2_PLURAL' | translate}}</span>
    </div>
    <div class="zk-flex sm:zk-justify-between md:zk-justify-end zk-items-center">
      <freud-button (click)="close()" color="ghost">{{'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.ACTIONS.CANCEL' | translate}}</freud-button>
      <freud-button [disabled]="!_selectedContacts?.length || sendingMessage" (click)="sendMessage()">{{'CONTACT.BANNER_INACTIVE_CLIENTS.MODAL.ACTIONS.SEND' | translate}}</freud-button>
    </div>
  </div>
</freud-dialog>
